import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import ResidentModel from "@/commons/models/Resident";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 利用者 API 操作クラス
 */
export default class ResidentGroupMembers {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET ResidentGroupMembers
   */
  public async get(
    userStore: LoginUser,
    groupId: number,
    queryParams?: { startIndex: number; endIndex: number; sortKey: string; order: string }
  ): Promise<Array<ResidentGroupMembersGetModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      groupId: groupId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.ResidentGroupMembers, formatParams);
    const params: any = queryParams ? queryParams : {};
    const response = await this.commonService.executeGet<Array<ResidentGroupMembersGetModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      params,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }
}

export interface ResidentGroupMembersGetModel extends ResidentModel {}
